import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import {
  ButtonGroup,
  Button,
  Stack,
  Pagination,
  Typography,
  Box,
  Drawer,
} from "@mui/material";
import {
  StyledPaper,
  StyledTable,
  StyledTableBody,
  StyledTableCell,
  StyledTableCell2,
  StyledTableContainer,
  StyledTableHead,
  StyledTableRow,
} from "../../CustomComponent/TableCompoent";
import {
  setSelectedMenu,
  getAvailableAgentList,
} from "../../Redux/Actions/actions";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, Label } from "recharts";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { IoIosArrowBack } from "react-icons/io";
import { FunnelSimple } from "@phosphor-icons/react";
import { Hourglass } from "react-loader-spinner";
import { toast } from "react-toastify";
import { toaststyle } from "../../Utils/toaststyle";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import Nographdata from "../../Assets/images/svg/nochart.svg";

const AgentReportHeaderDatas = [
  "Agent Name",
  "FRT<5 Min",
  "Resolution Time In<45min",
  "Resolution Time start<45min",
];

const customStyles = {
  control: (provided) => ({
    ...provided,
    fontSize: "13px",
  }),
};

// Custom Tooltip Component
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        {/* Agent Name */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <strong>{label}</strong>
        </div>
        {/* Data Values */}
        {payload.map((data, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "5px",
            }}
          >
            {/* Color Square */}
            <div
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: data.fill,
                marginRight: "8px",
              }}
            ></div>
            {/* Value */}
            <span>{`${data.value}%`}</span>
          </div>
        ))}
      </div>
    );
  }

  return null;
};

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};

const WhatsappChat = (props) => {
  const selectAgentRef = useRef(null);
  const animatedComponents = makeAnimated();
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [fromDateError, setFromDateError] = useState(false);
  const [toDateError, setToDateError] = useState(false);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [selectedagent, setSelectedagent] = useState([]);
  const [loadSpinner, setLoadSpinner] = useState("");
  const [whatsappReportlist, setWhatsappReportlist] = useState([]);
  const [whatsappReportlist2, setWhatsappReportlist2] = useState([]);
  const [whatsappReportlist3, setWhatsappReportlist3] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [showfilter, setShowFilter] = useState(false);

  const handelShowFilter = () => {
    setShowFilter(true);
  };
  const handelCloseFilter = () => {
    setShowFilter(false);
  };
  const filtersRef = useRef({
    startDate: fromdate ? fromdate : "",
    endDate: todate ? todate : "",
    agentId: selectedagent ? selectedagent.map((item) => item.value) : [],
  });

  const handleSubmit = () => {
    if (!fromdate) {
      setFromDateError(true);
      return;
    } else if (!todate) {
      setToDateError(true);
      return;
    } else if (moment(fromdate).isAfter(todate)) {
      setFromDateError(true);
      return;
    } else {
      filtersRef.current = {
        startDate: fromdate,
        endDate: todate,
        agentId: selectedagent.map((item) => item.value) || [],
      };
      setPage(1);
      whatsappChatApi(1);
      handelCloseFilter();
      setSelectedagent(selectedagent);
      setFromDateError(false);
      setToDateError(false);
    }
  };
  const resetButton = () => {
    selectAgentRef.current.clearValue();
    setFromdate(defaultValue);
    setTodate(defaultValue);
    setSelectedagent([]);
    setFromDateError(false);
    setToDateError(false);
  };

  const optionsAgent =
    props.DropDownAgentList &&
    props.DropDownAgentList.map((agent) => ({
      value: agent.id,
      label: agent.username,
    }));

  const handleSelectAgentChange = (selectedOptions) => {
    setSelectedagent(selectedOptions);
  };

  const whatsappChatApi = async (pageToFetch) => {
    const { startDate, endDate, agentId } = filtersRef.current;
    setLoadSpinner(true);
    await axios
      .post(
        BaseUrl + "/reports/whatsappChatReport",
        {
          startDate,
          endDate,
          agentId,
          limit: 10,
          offset: pageToFetch == 1 ? 0 : (pageToFetch - 1) * 10,
        },

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantid: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setLoadSpinner(true);
        if (res.data.success) {
          setLoadSpinner(false);
          setWhatsappReportlist3(res.data);

          const formattedData = res.data.Data.map((item) => {
            return {
              agentName: item.agentName,
              FRTPercentage: parseFloat(item.FRTPercentage),
            };
          });
          setWhatsappReportlist(formattedData);

          setWhatsappReportlist2(
            res.data.Data.map((item) => ({
              agentName: item.agentName,
              RTPercentage: parseFloat(item.RTPercentage),
              RTSPercentage: parseFloat(item.RTSPercentage),
            }))
          );
          setPagination(res.data.TotalAgent);
          toast.success(res.data.message, toaststyle);
        } else {
          setLoadSpinner(false);
          setWhatsappReportlist([]);
          setWhatsappReportlist2([]);
          setWhatsappReportlist3([]);
          setPagination(0);
          toast.warn(res.data.message, toaststyle);
        }
      })
      .catch((error) => {
        setLoadSpinner(false);
        setWhatsappReportlist([]);
        setWhatsappReportlist2([]);
        setWhatsappReportlist3([]);
        setPagination(0);
        console.log(error);
      });
  };

  const handleChange = async (event, value) => {
    setPage(value);
    await whatsappChatApi(value);
  };

  useEffect(() => {
    whatsappChatApi(page);
  }, []);

  return (
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Whatsapp Chat Report
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >
              {/* Back btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  props.setSelectedMenu("ReportMenu");
                }}
              >
                <IoIosArrowBack className="me-2" />
                Back
              </Button>

              {/* Filter btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={handelShowFilter}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "row",
            gap: "10",
          }}
        >
          <Stack
            // spacing={{ xs: 1, sm: 2 }}
            direction="row"
            useFlexGap
            sx={{
              flexWrap: "wrap",
              justifyContent: "space-around",
              display: "flex",
              width: "100%",
            }}
          >
            <Box>
              <Typography
                variant="h6"
                component="div"
                gutterBottom
                sx={{ fontSize: "12px" }}
              >
                {/* FRT &lt; 5min by AgentName */}
                FRT By AgentName
              </Typography>

              {whatsappReportlist.length > 0 ? (
                <BarChart width={550} height={180} data={whatsappReportlist}>
                  <XAxis
                    dataKey="agentName"
                    interval={0} // Ensure all labels are displayed
                    tickFormatter={(name) => name.split(" ")[0]} // Show only first name
                  >
                    <Label
                      value="Agent Name"
                      offset={-1}
                      position="insideBottom"
                    />
                  </XAxis>
                  <YAxis tickFormatter={(value) => `${value}%`}>
                    <Label
                      value="FRT Percentage"
                      angle={-90}
                      position="insideLeft"
                      style={{ textAnchor: "middle" }}
                    />
                  </YAxis>
                  <Tooltip />
                  <Legend verticalAlign="top" height={36} />
                  <Bar
                    name="FRT Percentage"
                    dataKey="FRTPercentage"
                    fill="#0083ff"
                  />
                </BarChart>
              ) : (
                <>
                  {/* Data unavailable start */}
                  <Stack
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Stack
                      className="text-muted"
                      direction="column"
                      justifyContent="center"
                      alignContent="center"
                    >
                      <span className="mx-auto">
                        <img
                          src={Nographdata}
                          alt="pic"
                          style={{
                            width: "10rem",
                            userSelect: "none",
                          }}
                        />
                      </span>
                      <span className="mx-auto">
                        <h6
                          className="text-muted mt-2 ms-4 ps-5"
                          style={{ fontSize: "13px" }}
                        >
                          Data unavailable
                        </h6>
                      </span>
                    </Stack>
                  </Stack>
                  {/* Data unavailable end */}
                </>
              )}
            </Box>

            <Box>
              <Typography
                variant="h6"
                component="div"
                gutterBottom
                sx={{ fontSize: "12px" }}
              >
                Resolution Time
              </Typography>
              {whatsappReportlist2 && whatsappReportlist2.length > 0 ? (
                <BarChart width={550} height={180} data={whatsappReportlist2}>
                  <XAxis
                    dataKey="agentName"
                    interval={0}
                    tickFormatter={(name) => name.split(" ")[0]}
                  >
                    <Label
                      value="Agent Name"
                      offset={-1}
                      position="insideBottom"
                    />
                  </XAxis>

                  <YAxis tickFormatter={(value) => `${value}%`}>
                    <Label
                      value="Resolution time"
                      angle={-90}
                      position="insideLeft"
                      style={{ textAnchor: "middle" }}
                    />
                  </YAxis>

                  <Tooltip content={<CustomTooltip />} />
                  <Legend verticalAlign="top" height={40} />

                  <Bar
                    name="Resolution time (Initiated_At to Ended_At)<45min"
                    dataKey="RTPercentage"
                    fill="#0083ff"
                  />

                  <Bar
                    name="Resolution time (started_At to Ended_At)<45min"
                    dataKey="RTSPercentage"
                    fill="#0606a0"
                  />
                </BarChart>
              ) : (
                <>
                  {/* Data unavailable start */}
                  <Stack
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Stack
                      className="text-muted"
                      direction="column"
                      justifyContent="center"
                      alignContent="center"
                    >
                      <span className="mx-auto">
                        <img
                          src={Nographdata}
                          alt="pic"
                          style={{
                            width: "10rem",
                            userSelect: "none",
                          }}
                        />
                      </span>
                      <span className="mx-auto">
                        <h6
                          className="text-muted mt-2 ms-4 ps-5"
                          style={{ fontSize: "13px" }}
                        >
                          Data unavailable
                        </h6>
                      </span>
                    </Stack>
                  </Stack>
                  {/* Data unavailable end */}
                </>
              )}
            </Box>

            <Box className="w-100">
              <StyledTableContainer
                sx={{ height: "13rem !important", width: "100% !important" }}
              >
                <StyledTable
                  stickyHeader
                  aria-label="sticky table"
                  size="small"
                  className="w-100"
                >
                  <StyledTableHead>
                    <StyledTableRow>
                      {AgentReportHeaderDatas.map((headers) => (
                        <StyledTableCell style={{ minWidth: "150px" }}>
                          {headers}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </StyledTableHead>
                  <StyledTableBody>
                    {loadSpinner ? (
                      <Stack
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <Hourglass
                          visible={true}
                          height="30"
                          width="30"
                          ariaLabel="hourglass-loading"
                          colors={["#2268a0", "#72a1ed"]}
                        />
                      </Stack>
                    ) : (
                      <>
                        {/* Data Rows */}
                        {whatsappReportlist3?.Data &&
                        whatsappReportlist3?.Data.length > 0 ? (
                          <>
                            {whatsappReportlist3?.Data.map((item, index) => (
                              <StyledTableRow
                                hover
                                role="checkbox"
                                key={item.id || index}
                              >
                                <StyledTableCell2>
                                  {item.agentName || "--"}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {item.FRTPercentage || "--"}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {item.RTPercentage || "--"}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {item.RTSPercentage || "--"}
                                </StyledTableCell2>
                              </StyledTableRow>
                            ))}

                            <StyledTableRow hover role="checkbox">
                              <StyledTableCell2>
                                <strong>Total Percentage</strong>
                              </StyledTableCell2>
                              <StyledTableCell2>
                                <strong>
                                  {whatsappReportlist3?.TotalFRTPercentage ||
                                    "--"}
                                  %
                                </strong>
                              </StyledTableCell2>
                              <StyledTableCell2>
                                <strong>
                                  {whatsappReportlist3?.TotalRTPercentage ||
                                    "--"}
                                  %
                                </strong>
                              </StyledTableCell2>
                              <StyledTableCell2>
                                <strong>
                                  {whatsappReportlist3?.TotalRTSPercentage ||
                                    "--"}
                                  %
                                </strong>
                              </StyledTableCell2>
                            </StyledTableRow>
                          </>
                        ) : (
                          // No Data Available
                          <Stack
                            sx={{
                              position: "absolute",
                              width: "100%",
                              height: "calc(100vh - 14rem)",
                              marginBottom: "15rem",
                            }}
                            justifyContent="center"
                            alignItems="center"
                          >
                            <img
                              src={Nodata}
                              alt="No data available"
                              style={{
                                width: "11rem",
                                userSelect: "none",
                                marginTop: "-14rem",
                              }}
                            />
                            <h6
                              className="text-muted mt-3"
                              style={{ fontSize: "13px", textAlign: "center" }}
                            >
                              Data unavailable
                            </h6>
                          </Stack>
                        )}
                      </>
                    )}
                  </StyledTableBody>
                </StyledTable>
              </StyledTableContainer>
            </Box>
          </Stack>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                {`Showing ${Math.min(
                  (page - 1) * 10 + 1,
                  isNaN(pagination) ? 0 : pagination
                )} to ${Math.min(
                  page * 10,
                  isNaN(pagination) ? 0 : pagination
                )} of ${isNaN(pagination) ? 0 : pagination} entries`}
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                variant="outlined"
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>

      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setShowFilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">
              <div className="p-2">
                <div className="mb-3 d-flex flex-column text-start">
                  <label for="exampleInputtodate" className="form-label">
                    From Date <small className="text-danger">*</small>
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    id="exampleInputfromdate"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                  {fromDateError && moment(fromdate).isAfter(todate) && (
                    <span
                      className="text-danger mt-2"
                      style={{ fontSize: "10px" }}
                    >
                      From date should be less than To date
                    </span>
                  )}
                  {fromDateError &&
                    !moment(fromdate).isAfter(todate) &&
                    !fromdate && (
                      <span
                        className="text-danger mt-2"
                        style={{ fontSize: "10px" }}
                      >
                        From date is required
                      </span>
                    )}
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label for="exampleInputtodate" className="form-label">
                    To Date <small className="text-danger">*</small>
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    id="exampleInputtodate"
                    value={todate}
                    onChange={(e) => setTodate(e.target.value)}
                    max={defaultValue}
                  />
                  {toDateError &&
                    !moment(defaultValue).isBefore(todate) &&
                    !todate && (
                      <span
                        className="text-danger mt-2"
                        style={{ fontSize: "10px" }}
                      >
                        To date is required
                      </span>
                    )}
                </div>

                <div className="mb-3">
                  <label for="exampleInputfromdate" className="form-label">
                    Agent <small className="text-danger">*</small>
                  </label>
                  <Select
                    isMulti
                    ref={selectAgentRef}
                    placeholder="Select Agent"
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    options={optionsAgent}
                    styles={customStyles}
                    defaultValue={selectedagent}
                    onChange={handleSelectAgentChange}
                    onClick={() => {
                      if (basedOnRole.role == "Supervisor") {
                        props.getAvailableAgentList();
                      }
                    }}
                  />
                </div>
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={handelCloseFilter}
            >
              Close
            </Button>
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="warning"
              disableElevation
              onClick={resetButton}
            >
              Reset
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer End  */}
    </StyledPaper>
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
  getAvailableAgentList,
})(WhatsappChat);
